export enum DeviceTypes {
    DESKTOP = 'DESKTOP',
    MOBILE = 'MOBILE'
}
